export const LibraryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M5 4h12a2 2 0 012 2v14H7a2 2 0 01-2-2z"></path>
      <path d="M5 4a2 2 0 00-2 2v12"></path>
    </svg>
  );
};
